<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn @click="openDialog()" :color="ui.btnColor" flat dark>
        <v-icon left>
          search
        </v-icon>
        search
      </v-btn>
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title class="title wplblue1--text">
            {{data.title}}
          </v-card-title>
          <v-progress-linear :color="ui.btnColor" height="1" value="100">
          </v-progress-linear>
          <v-form
            ref="form"
            v-model="valid"
            v-on:submit.prevent="validate"
            lazy-validation>
            <v-container>
              <v-layout row>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="search.title"
                    label="search user name"
                    prepend-icon="person"
                    @keyup.enter="validate"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md6 lg6>
                  <v-select
                    v-model="search.status"
                    :items="searchUserStatus"
                    color="wplblue0"
                    prepend-icon="verified_user"
                    hint="user status"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6>
                  <v-select
                    v-model="search.licence"
                    :items="searchUserLicence"
                    color="wplblue0"
                    prepend-icon="dashboard_customize"
                    hint="user licence"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>            
              </v-layout>
            </v-container>
            <v-layout  row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
              <v-spacer/>
              <div v-if="enableSpinBtnReview === false">
                <v-btn :disabled="reviewDisable" :color="ui.btnColor"
                  @click="validate('review')" flat>
                  <v-icon left> person </v-icon>
                    review
                </v-btn>
              </div>
              <div v-else>
                <BtnSpin :btnSpec="btnInfo1"/>
              </div>
              <div v-if="enableSpinBtnSearch === false">
                <v-btn :disabled="searchDisable" :color="ui.btnColor"
                  @click="validate('search')" flat>
                  <v-icon left> search </v-icon>
                    search
                </v-btn>
              </div>
              <div v-else>
                <BtnSpin :btnSpec="btnInfo1"/>
              </div>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import searchUsers from "@/data/search/mixins/searchUsers.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import selectSearch from "@/data/options/mixins/selectSearch.js";

export default {
  // eslint-disable-next-line
  mixins: [searchUsers, apptheme, dataSources, selectSearch],
  components: {
    BtnSpin
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(["getProcedure", "getCurrentPage"]),
    // selected task item
    selectedAsset() {
      return "Hello";
    },
    searchDisable() {
      if (this.search.title !== "") {
        return false;
      } else {
        return true;
      }
    },
    reviewDisable() {
      if (this.search.status !== null) {
        return false;
      } else {
        return true;
      }
    },
    searchTitle() {
      let title = null;
      if (this.getCurrentPage === "/userdash") {
        title = "Compnay Access Search";
      } else {
        title = "Search";
      }
      return title;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinBtnSearch: false,
      enableSpinBtnReview: false,
      search: {
        id: "", // id for search
        title: "", // title for search
        dbs: "", // data base source
        status: null,
        licence: ""
      },
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.enableSpinBtnSearch = false;
      this.enableSpinBtnReview = false;
      // reset
      this.search.status = null;
      this.search.title = "";
      this.search.licence = "";
      // Define search
      this.search.dbs = this.defineDataSourceFromTag(this.data.tag);
      this.$store.dispatch("changeSearchResults", null);
    },
    closeDialog() {
      this.dialog = false;
      // this.$store.dispatch("changeDataReach", "");
      // this.$store.dispatch("changeDataSource", "");
    },
    validate(btn) {
      // convert stats to true / false
      if (this.search.status === "Active") {
        this.search.status = true;
      }

      if (this.search.status === "Disabled") {
        this.search.status = false;
      }

      if (btn === "search") {
        this.enableSpinBtnSearch = true;
      } else {
        this.enableSpinBtnReview = true;
      }

      if (this.$refs.form.validate() === true) {
        this.searchUsers(this.search);
      }
    }
  }
};
</script>
